import React from 'react';
import PlannedReturn from '../PlannedReturn/Desktop';
import ReturnDate from '../ReturnDate/Desktop';
import ReturnTrip from '../ReturnTrip/Desktop';
import ReturnDirection from '../ReturnDirection/Desktop';
import builder from './builder';
import {
  START_RETURN_BOOKING,
  RETURN_TRIP_BOOKED,
  RETURN_DATE_SELECTED
} from 'app/constants';

import style from './style.css';

// Mapping from current booking state to
// appropreate component for moving to the next state
const STATE_TO_COMP = {
  [START_RETURN_BOOKING]: ReturnDate,
  [RETURN_DATE_SELECTED]: ReturnTrip,
  [RETURN_TRIP_BOOKED]: ReturnDirection
};

/**
 * The component renders different components depending on current
 * return trip booking state.
 */
export const DesktopBookReturnTrip = (props) => {
  const { readOnly, locked, returnBookState } = props;
  if ((readOnly || locked) && returnBookState !== RETURN_TRIP_BOOKED) return null;
  const FieldComponent = STATE_TO_COMP[returnBookState] || PlannedReturn;

  return (
    <span className={style.container}>
      <FieldComponent {...props} />
    </span>
  );
};

// TODO: move to Flow types
// DesktopBookReturnTrip.propTypes = {
//   readOnly: PropTypes.bool,
//   locked: PropTypes.bool,
//   returnBookState: PropTypes.string
// };

export default builder(DesktopBookReturnTrip);
